import request from '../request'

//删除
export function deleteShipType(id) {
    return request({
        url: '/wx/deleteType?id=' + id,
        method: 'get',
        data: {}
    })
}

export function createshipType(data) {
    return request({
        url: '/wx/createType',
        method: 'post',
        data: data
    })
}

export function updateshipType(data){
    return request({
        url: '/wx/updateType',
        method: 'post',
        data: data
    })
}